const styles = {
    month: {
        fontSize: "23px",
        textAlign: "center",
        paddingTop: "16px",
        marginTop: "0"
    },
}

export default styles;
